/**
 * Brand color palette for saVin app
 * Based on brand guidelines from October 2025
 */

export const brandColors = {
  // Primary brand colors
  britishRacingGreen: '#043325',
  mutedBrass: '#B08057',
  warmIvory: '#FBE8D0',

  // Secondary shades
  deepForest: '#08604C',
  softSageGrey: '#F5F6F4', // Soft neutral for landing pages (replaces antique cream)

  // Semantic color mapping
  primary: '#043325', // British Racing Green
  primaryHover: '#08604C', // Darker shade for hover states
  accent: '#B08057', // Muted Brass
  accentHover: '#9A6D47', // Darker shade of Muted Brass for hover states
  background: '#F5F6F4', // Soft Sage Grey (app-wide background)

  // Functional colors (maintaining current functionality)
  success: '#10b981', // Keep green for success states
  warning: '#f59e0b', // Keep amber for warnings
  error: '#ef4444', // Keep red for errors
  info: '#3b82f6', // Keep blue for info
} as const;

export type BrandColor = keyof typeof brandColors;
